import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GetProviderStates = (params = {}) => async () => {
  try {
    const response = await axios({
      method: "get",
      url: `${actionType.environment_url}/api/admin/GetProviderStates`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      params,
    });
    return response.data;
  } catch (error) {
    return error?.response?.data ?? { success: false, message: error.message };
  }
};
